/*!

=========================================================
* Now UI Dashboard React - v1.5.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import WallofLove from "views/WallofLove";
import Performance from "views/Performance";
import Dashboard from "views/Dashboard.js";
import Notifications from "views/Notifications.js";
import Groups from "views/Groups.js";
import Typography from "views/Typography.js";
import TableList from "views/TableList.js";
import Maps from "views/Maps.js";
import Upgrade from "views/Upgrade.js";
import UserPage from "views/UserPage.js";
import Capstone from "components/Capstone/Capstone";
import Classrooms from "components/Classrooms/Classrooms";
import Calendar from "views/Calendar";
import IndProjects from "views/IndProjects";
import Schedual from "views/Schedual";
import Interventions from "views/Interventions";

import Courses from "views/Courses";
import ProgressReport from "views/ProgressReport";
import GroupProjects from "views/GroupProjects";
import LearningStyle from "views/LearningStyle/LearningStyle";
import CareerPath from "views/CareerPath/CareerPath";
import Passion from "views/passion/passion";
import CareerTestResult from "views/CareerPath/CareerTestResult";
import StudentDashboard from "views/capstone/Dashboard";
import AcademicInterventions from "views/AcademicInterventions/AcademicInterventions";
import MyBragSheet from "views/MyBragSheet/MyBragSheet";
var dashRoutes = [
  {
    path: "/home",
    name: "HOME",
    icon: "shopping_shop",
    component: Dashboard,
    style: "white",
  },
  {
    path: "/mybragsheet",
    name: "My Brag Sheet",
    icon: "files_single-copy-04",
    component: MyBragSheet,
    style: "white",
  },
  {
    path: "/performance",
    name: "PERFORMANCE",
    icon: "media-2_sound-wave",
    component: Performance,
    style: "white",
  },
  {
    path: "/StudentDashboard",
    name: "Capstone",
    icon: "media-2_sound-wave",
    component: StudentDashboard,
    style: "white",
  },
  {
    path: "/groups",
    name: "GROUPS",
    icon: "users_single-02",
    component: Groups,
    style: "white",
  },
  {
    path: "/projects",
    name: "INDIVIDUAL PROJECTS",
    icon: "business_briefcase-24",
    component: IndProjects,
    style: "white",
  },
  {
    path: "/groupprojects",
    name: "Group PROJECTS",
    icon: "business_briefcase-24",
    component: GroupProjects,
    style: "white",
  },
  {
    path: "/schedule",
    name: "SCHEDULE",
    icon: "ui-2_time-alarm",
    component: Schedual,
    style: "white",
  },
  // {
  //   path: "/calendar",
  //   name: "CALENDAR",
  //   icon: "ui-1_calendar-60",
  //   component: Calendar,
  // },
  {
    path: "/academicinterventions",
    name: "Academic Interventions",
    icon: "files_single-copy-04",
    component: AcademicInterventions,
    style: "white",
  },
  {
    path: "/interventions",
    name: "Interventions",
    icon: "media-1_button-pause",
    component: Interventions,
    style: "white",
  },
  {
    path: "/course",
    name: "Courses",
    icon: "files_single-copy-04",
    component: Courses,
    style: "white",
  },
  {
    path: "/progress-report",
    name: "Progress Report",
    icon: "files_paper",
    component: ProgressReport,
    style: "white",
  },
  {
    path: "/learningstyle",
    name: "Learning Style",
    icon: "files_paper",
    component: LearningStyle,
    style: "white",
  },
  {
    path: "/careerpath",
    name: "Career Path",
    icon: "files_paper",
    component: CareerPath,
    style: "white",
  },
  {
    path: "/passion",
    name: "What is my Passion?",
    icon: "files_paper",
    component: Passion,
    style: "white",
  },

  {
    path: "/walloflove",
    name: "Wall Of Love",
    icon: "fas fa-heart",
    component: WallofLove,
    style: "red",
  },
  // {
  //   path: "/capstones",
  //   name: "Capstones",
  //   icon: "files_paper",
  //   component: Capstone,
  //   layout: "/admin",
  // },
  // {
  //   path: "/classrooms",
  //   name: "Classrooms",
  //   icon: "files_paper",
  //   component: Classrooms,
  //   layout: "/admin",
  // },
  // {
  //   path: "/typography",
  //   name: "Typography",
  //   icon: "design-2_ruler-pencil",
  //   component: Typography,
  //   layout: "/admin",
  // }
];
export default dashRoutes;
